@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.promotional-section {
  flex: 1;
  background: var(--green-00331C) url('../../set-up-banner/svgs/shipstation-icon.svg') no-repeat left 380px top 130px;
  padding: @space-24;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0 8px 8px 0;
}

.promotional-content {
  align-items: flex-start;
  gap: @space-16;
  max-width: 380px;
}

.promotional-header {
  color: var(--white);
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  margin: 0;
}

.promotional-subtext {
  color: var(--white);
}

.carrier-logo {
  width: auto;
  height: 40px;
  padding: 0;
  margin-top: @space-8;
}

@media screen and (max-width: 768px) {
  .promotional-section {
    padding: @space-20;
  }

  .promotional-content {
    max-width: none;
    text-align: center;
    align-items: flex-start;
  }
}
